import { ArrayFieldset, ArrayFieldsetInner, DynamicFieldsetModule } from '@common/forms/frontend-shared';
import { CrudEditorComponent } from './crud-editor/crud-editor.component';
import { CrudFieldsetComponent } from './crud-fieldset/crud-fieldset.component';
import { CrudListItemComponent } from './crud-list/crud-list-item.component';
import { CrudListComponent } from './crud-list/crud-list.component';
import { CrudManager2Component } from './crud-manager';
import { CrudManagerLayoutListComponent, CrudManagerLayoutTableComponent } from './crud-manager/layouts';
import { CrudTableItemComponent } from './crud-table/crud-table-item.component';
import { CrudTableComponent } from './crud-table/crud-table.component';
import * as i0 from "@angular/core";
const Components = [CrudFieldsetComponent, CrudListComponent, CrudTableComponent, CrudListItemComponent, CrudTableItemComponent, CrudEditorComponent, CrudManagerLayoutTableComponent, CrudManagerLayoutListComponent, CrudManager2Component, ArrayFieldset, ArrayFieldsetInner];
export let CrudUiFrontendSharedModule = /*#__PURE__*/(() => {
  class CrudUiFrontendSharedModule {
    static {
      this.ɵfac = function CrudUiFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudUiFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CrudUiFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [DynamicFieldsetModule, Components, DynamicFieldsetModule]
      });
    }
  }
  return CrudUiFrontendSharedModule;
})();